import { render, staticRenderFns } from "./ComForm2.vue?vue&type=template&id=3833ea98&scoped=true&"
import script from "./ComForm2.vue?vue&type=script&lang=js&"
export * from "./ComForm2.vue?vue&type=script&lang=js&"
import style0 from "./ComForm2.vue?vue&type=style&index=0&id=3833ea98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3833ea98",
  null
  
)

export default component.exports